import {
  FluidPaginationState,
  FluidRowData,
  FluidTheme,
  SEARCHED,
} from '@lmig/fluid-core';
import { FluidTableTranslationOptions } from '@lmig/fluid-core/lib/i18n/types/fluid-table-translation-options.type';
import { h } from '@stencil/core';

import { FILTERED } from '../../../constants/constants';

export type TablePaginatorProps = {
  paginated: boolean;
  dataItems: FluidRowData[];
  theme: FluidTheme;
  overrideGlobalTheme: boolean;
  rangeIndicatorTemplate: string;
  itemsPerPageTemplate: string;
  paginationItemsPerPageOptions: number[];
  isPaginatorTotalItemsDisabled: boolean;

  setPaginatorRef: (ref: HTMLFluidPaginatorElement) => void;
  onPageChanged: (paginationState: FluidPaginationState) => void;
  fluidTranslate?: FluidTableTranslationOptions;
  identifier: string;
  defaultPageSize?: number | 'total';
};
export const Paginator = (props: TablePaginatorProps) => {
  const {
    paginated,
    dataItems,
    setPaginatorRef,
    onPageChanged,
    itemsPerPageTemplate,
    isPaginatorTotalItemsDisabled,
    paginationItemsPerPageOptions,
    rangeIndicatorTemplate,
    overrideGlobalTheme,
    theme,
    defaultPageSize,
    fluidTranslate,
    identifier,
  } = props;
  const pageableDataItems = dataItems.filter(
    (dataItem) => !dataItem[FILTERED] && !dataItem[SEARCHED]
  );
  return (
    paginated &&
    pageableDataItems.length > 0 && (
      <fluid-paginator
        identifier={identifier}
        data-test-id={`${identifier}-paginator-wrapper`}
        fluidTranslate={fluidTranslate?.paginator}
        theme={theme}
        defaultPageSize={defaultPageSize}
        overrideGlobalTheme={overrideGlobalTheme}
        rangeIndicatorTemplate={rangeIndicatorTemplate}
        itemsPerPageTemplate={itemsPerPageTemplate}
        itemsPerPageOptions={paginationItemsPerPageOptions}
        isTotalItemsDisabled={isPaginatorTotalItemsDisabled}
        dataItems={pageableDataItems}
        ref={(paginator: HTMLFluidPaginatorElement) =>
          setPaginatorRef(paginator)
        }
        onPageChanged={(event: CustomEvent) => onPageChanged(event.detail)}
      />
    )
  );
};
